import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import makePendingActions from '../../redux/pending/actions';
import TextInput from '../TextInput';

const pendingActions = makePendingActions({});

const isNumberInput = (t) => Boolean(t) && t === `number`;

/**
 * Wraps a TextInput and connects it to the pending data model. Automatically
 * sets the initial data for the input and updates the pending data whenever
 * a change event is fired.
 *
 * @public
 * @author Connor Taylor
 */
export class PendingInput extends Component {
  componentDidMount() {
    const {
      updatePendingData,
      pendingKey,
      valueKey,
      initialData,
      type,
      value,
    } = this.props;

    if (value) {
      return;
    }

    const initialValue = isNumberInput(type) && !initialData ? 0 : initialData;

    updatePendingData({
      changes: { [valueKey]: initialValue },
      id: pendingKey,
    });
  }

  onChange = (e) => {
    const { updatePendingData, pendingKey, valueKey, onChange } = this.props;
    const value = e.target ? e.target.value : e;

    updatePendingData({
      changes: { [valueKey]: value },
      id: pendingKey,
    });

    if (onChange) {
      onChange(e);
    }
  };

  render() {
    const {
      updatePendingData,
      pendingKey,
      valueKey,
      initialData,
      ...rest
    } = this.props;

    return <TextInput {...rest} onChange={this.onChange} />;
  }
}

PendingInput.propTypes = {
  /** The type of the input
   * @ignore
   */
  type: PropTypes.string,
  /** The value of the input
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** The function to fire that updates the pending data
   * @ignore
   */
  updatePendingData: PropTypes.func.isRequired,
  /** The key for the pending data (eg. `state.pending.data[pendingKey]`) */
  pendingKey: PropTypes.string.isRequired,
  /** The key for the value (eg. `state.pending.data[pendingKey][valueKey]`) */
  valueKey: PropTypes.string.isRequired,
  /** A value to prepopulate the input with */
  initialData: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** A function that fires whenever a change event happens */
  onChange: PropTypes.func,
};

PendingInput.defaultProps = {
  initialData: ``,
};

export default connect(
  (state, props) => {
    const { pendingKey, valueKey, type } = props;
    const value
      = state.pending
      && state.pending.data
      && state.pending.data[pendingKey]
      && state.pending.data[pendingKey][valueKey];

    // Default value is 0 for numbers
    const defaultValue = type && type === `number` ? 0 : ``;

    // Make value the empty string by default to prevent any uncontrolled
    // component warnings from popping up
    return { value: value || defaultValue };
  },
  {
    updatePendingData: pendingActions.updatePendingData,
  },
)(PendingInput);
